import React, { useState } from "react";
import TableSearchInput from "../TableSearchInput";
import { Box } from "@mui/material";

const ZoneAssignmentSearchInput = ({ updateSearchValue, updateRefreshKey }) => {
  const [query, setQuery] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value === "") {
      updateSearchValue("");
      updateRefreshKey((key) => key + 1);
    } else {
      updateSearchValue(value.trim());
    }
  };

  return (
    <Box>
      <TableSearchInput
        searchQuery={query}
        onSearchChange={handleInputChange}
        tooltip="Search Van, Zone, Driver"
        placeholder="Search Van, Zone, Driver"
      />
    </Box>
  );
};

export default ZoneAssignmentSearchInput;
